import React, { useEffect } from 'react'
import BreadCrumb from '../breadcrumb/BreadCrumb'
import { useTranslation } from "react-i18next";
import { ROUTE } from '../../route/Route';
import SeoAdd from '../Seo/SeoAdd';

const Disclaimer = () => {
    const { t } = useTranslation();
    useEffect(() => {
        window?.scrollTo(0, 0);
        return () => {}
    }, [])
    return (
        <>
        <SeoAdd slug={ROUTE.DISCLAIMER} />
        <div className="content pb-0 pt-0 bg-gray">
            <BreadCrumb page={t("declaimer")} data={{slug: "", path: ""}}/> 
			<section className="about-section">
				<div className="container" id="section2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="overview-wrap">
                                <div className="headingmains text-center pb-4">
                                    <h1 className="right">{t("declaimer")}</h1>
                                </div>
                                <ul className='policy'>
                                <li ><a href="https://oncquestlabs.com"  target="_blank">www.oncquestlabs.com</a> {t("declaimer_info1")}</li>
                                <li >{t("declaimer_info2")}</li>
                                <li >{t("declaimer_info3")}</li>
                                <li >{t("declaimer_info4")}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        </>
    )
}

export default Disclaimer
